import moment from 'moment';

import type { APIData } from 'webapp-types';
import type { PromotionIdentifier, PromotionType } from 'webapp/enums/enums';

import Serviced from 'webapp/models-custom/serviced';

export default class ExpiredPromotion extends Serviced {
	// --- BE fields, Sync with APIData.Billing.Promotions.ExpiredItem
	activeUntil: number;
	completed: number;
	coupon: string | null;
	identifier: PromotionIdentifier;
	isCommitment: boolean;
	productId: string;
	resetBillingCycle: boolean;
	type: PromotionType;
	// --- BE fields

	constructor(model: APIData.Billing.Promotions.ExpiredItem) {
		super();

		this.activeUntil = model.activeUntil;
		this.completed = model.completed;
		this.coupon = model.coupon;
		this.identifier = model.identifier;
		this.isCommitment = model.isCommitment;
		this.productId = model.productId;
		this.resetBillingCycle = model.resetBillingCycle;
		this.type = model.type;
	}

	get isWithin14DaysAfter(): boolean {
		return this.isWithinDaysAfter(14);
	}

	get isWithin30DaysAfter(): boolean {
		return this.isWithinDaysAfter(30);
	}

	private isWithinDaysAfter(days: number): boolean {
		const now = moment();
		const expirationMoment = moment.unix(this.completed);
		const daysSinceExpiration = now.diff(expirationMoment, 'days');
		return daysSinceExpiration >= 0 && daysSinceExpiration <= days;
	}
}
